import { Box, VStack } from "@chakra-ui/react";
import { useHistory, useLocation } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";
import { NavigationBarButton } from "components/LayoutComponents";

import { LogoutNavigationButton } from "./LogoutNavigationButton";

const ProfileMenu = () => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();
  const location = useLocation();

  return (
    <Box overflowY="auto">
      <VStack spacing="30px" mt={2} p={4}>
        <NavigationBarButton
          onClick={() => {
            push(`/e-rezerwacja/${friendlyUrl}`);
          }}
          id="user-navigation-main-page-btn"
        >
          <ChakraText>Strona główna</ChakraText>
        </NavigationBarButton>
        <NavigationBarButton
          isActive={location.pathname.includes("profil")}
          onClick={() => {
            push(`/e-rezerwacja/${friendlyUrl}/uzytkownik/profil`);
          }}
          id="user-navigation-profile-btn"
        >
          <ChakraText>Profil użytkownika</ChakraText>
        </NavigationBarButton>
        <NavigationBarButton
          isActive={location.pathname.includes("aktualne-wizyty")}
          onClick={() => {
            push(`/e-rezerwacja/${friendlyUrl}/uzytkownik/aktualne-wizyty`);
          }}
          id="user-navigation-actual-appointment-btn"
        >
          <ChakraText>Aktualne wizyty</ChakraText>
        </NavigationBarButton>
        <NavigationBarButton
          isActive={location.pathname.includes("historyczne-wizyty")}
          onClick={() => {
            push(`/e-rezerwacja/${friendlyUrl}/uzytkownik/historyczne-wizyty`);
          }}
          id="user-navigation-historical-appointment-btn"
        >
          <ChakraText>Historyczne wizyty</ChakraText>
        </NavigationBarButton>
        <LogoutNavigationButton />
      </VStack>
    </Box>
  );
};

export { ProfileMenu };
